import { Button, Popconfirm } from "antd";
import dayjs from "dayjs";

// Function to render the condition based on promotionType
const renderCondition = (record) => {
  if (record.promotionType === "Last Minute") {
    return `Days before Check-in: ${record.condition.lastMinuteDays}`;
  } else if (record.promotionType === "Early Bird") {
    return `Days in Advance: ${record.condition.earlyBirdDays}`;
  }
  return "N/A"; // For promotions without specific conditions like Basic Deal, Seasonal, etc.
};

export const getColumns = ({ handleEdit, handleDelete }) => [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Type",
    dataIndex: "promotionType",
    key: "promotionType",
  },
  {
    title: "Discount (%)",
    dataIndex: "discountPercentage",
    key: "discountPercentage",
  },
  {
    title: "Applicable Stay Dates",
    dataIndex: "applicableStayDates",
    key: "applicableStayDates",
    render: (dates) =>
      `${dayjs(dates.startDate).format("DD-MM-YYYY")} to ${dayjs(
        dates.endDate
      ).format("DD-MM-YYYY")}`,
  },
  {
    title: "Applicable Book Dates",
    dataIndex: "applicableBookDates",
    key: "applicableBookDates",
    render: (dates) =>
      `${dayjs(dates.startDate).format("DD-MM-YYYY")} to ${dayjs(
        dates.endDate
      ).format("DD-MM-YYYY")}`,
  },
  {
    title: "Condition",
    key: "condition",
    render: (text, record) => renderCondition(record), // Render condition dynamically based on promotion type
  },
  {
    title: "Actions",
    key: "actions",
    render: (text, record) => (
      <>
        <Button
          onClick={() => handleEdit(record)}
          type="primary"
          style={{ marginRight: 8 }}
        >
          Edit
        </Button>
        <Popconfirm
          title="Are you sure to delete this promotion?"
          onConfirm={() => handleDelete(record._id)}
          onCancel={() => {}}
          okText="Yes"
          cancelText="No"
        >
          <Button type="link" danger>
            Delete
          </Button>
        </Popconfirm>
      </>
    ),
  },
];
